module.exports = __webpack_public_path__ + "static/lyon-financial-3ea6d1133ad0bea06569ecb36999dbe3.png";